import React from "react";
import { Box, Text, HStack, Link } from "@chakra-ui/react";

const Footer = () => {
  return (
    <Box as="footer" py={6} textAlign="center" color="gray.400">
      <HStack justify="center" spacing={6}>
        <Link href="/privacy.html" isExternal>
          Privacy Policy
        </Link>
        <Link href="/terms.html" isExternal>
          Terms of Service
        </Link>
      </HStack>
      <Text fontSize="sm" mt={2}>
        &copy; {new Date().getFullYear()} PiChart – All rights reserved.
      </Text>
    </Box>
  );
};

export default Footer;
